var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show == true)?_c('vc-crud',{attrs:{"close":"","noBorder":"","noDark":"","searchInput":"","title":"Listado de Personas","filter":_vm.filterGrid,"config":this.config},on:{"doubleClick":function($event){return _vm.doubleClick($event)},"close":function($event){return _vm.$emit('close')}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }